import { observer } from 'mobx-react-lite'
import { type TextQuestionAnswerEditorViewModel } from '@/features/jobs/questions/text/TextQuestionAnswerEditorViewModel'
import { TextQuestionAnswerEditor } from './'

export interface TextQuestionAnswerEditorContainerProps {
  questionId: string
  editorVm: TextQuestionAnswerEditorViewModel
  isDisabled?: boolean
  'aria-label'?: string
  'aria-labelledby'?: string
  'aria-describedby'?: string
}

export const TextQuestionAnswerEditorContainer = observer(
  function TextQuestionAnswerEditorContainer({
    editorVm,
    questionId,
    isDisabled,
    ...rest
  }: TextQuestionAnswerEditorContainerProps) {
    return (
      <TextQuestionAnswerEditor
        value={editorVm.editingValue}
        onChange={editorVm.setEditingText}
        isDisabled={isDisabled}
        onBlur={editorVm.flush}
        testId={`text-question-answer-editor-${questionId}`}
        {...rest}
      />
    )
  },
)
